export let BlendType = /*#__PURE__*/function (BlendType) {
  BlendType["normal"] = "normal";
  BlendType["additive"] = "additive";
  BlendType["subtractive"] = "subtractive";
  BlendType["min"] = "min";
  BlendType["max"] = "max";
  BlendType["none"] = "none";
  return BlendType;
}({});

// 交互样式

// 分段图例

// 分类图例

// 图层图例

export let StencilType = /*#__PURE__*/function (StencilType) {
  StencilType["MULTIPLE"] = "MULTIPLE";
  StencilType["SINGLE"] = "SINGLE";
  return StencilType;
}({});
export let MaskOperation = /*#__PURE__*/function (MaskOperation) {
  MaskOperation["AND"] = "and";
  MaskOperation["OR"] = "or";
  return MaskOperation;
}({});

/**
 * For tile subLayer
 */

export let ILayerStage = /*#__PURE__*/function (ILayerStage) {
  ILayerStage["INIT"] = "init";
  ILayerStage["UPDATE"] = "update";
  return ILayerStage;
}({});

/**
 * Layer 插件
 */

/**
 * Layer 初始化参数
 */

/**
 * 提供 Layer 管理服务
 */